/* tslint:disable */
/* eslint-disable */
/**
 * care-plan
 * care-plan
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TaskInstanceHistoryListEntry } from './TaskInstanceHistoryListEntry';
import {
    TaskInstanceHistoryListEntryFromJSON,
    TaskInstanceHistoryListEntryFromJSONTyped,
    TaskInstanceHistoryListEntryToJSON,
} from './TaskInstanceHistoryListEntry';

/**
 * 
 * @export
 * @interface FindAllInstanceHistory200Response
 */
export interface FindAllInstanceHistory200Response {
    /**
     * 
     * @type {Array<TaskInstanceHistoryListEntry>}
     * @memberof FindAllInstanceHistory200Response
     */
    data?: Array<TaskInstanceHistoryListEntry>;
}

/**
 * Check if a given object implements the FindAllInstanceHistory200Response interface.
 */
export function instanceOfFindAllInstanceHistory200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllInstanceHistory200ResponseFromJSON(json: any): FindAllInstanceHistory200Response {
    return FindAllInstanceHistory200ResponseFromJSONTyped(json, false);
}

export function FindAllInstanceHistory200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllInstanceHistory200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(TaskInstanceHistoryListEntryFromJSON)),
    };
}

export function FindAllInstanceHistory200ResponseToJSON(value?: FindAllInstanceHistory200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(TaskInstanceHistoryListEntryToJSON)),
    };
}

